import React, { Component } from 'react'
import trans from 'counterpart'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import SubjectPicker from './pickers/SubjectPicker'
import ArrivalDatePicker from './pickers/ArrivalDatePicker'
import DepartureDatePicker from './pickers/DepartureDatePicker'
import RefineFiltersPicker from './pickers/RefineFiltersPicker'
import { setIsLoading, fetchSubjects, fetchPropertyGroups } from '../actions'
import { updateQueryString } from '../../../actions/preferenceActions'
import { getQueryString } from '../../../selectors/preferenceSelectors'
import Link from '../../../components/typography/Link'

class Filters extends Component {
  constructor (props) {
    super(props)

    this.departurePicker = React.createRef()
    this.refineFilters = React.createRef()
  }

  componentDidMount = () => {
    const { initialize, setLoading } = this.props
    return initialize()
      .then(() => setLoading())
  }

  toggle = (type, bool) => {
    if (type === 'openDeparture') {
      if (bool) {
        this.departurePicker.current.open()
      } else {
        this.departurePicker.current.close()
      }
    } else if (type === 'openFilters') {
      if (bool) {
        this.refineFilters.current.open()
      } else {
        this.refineFilters.current.close()
      }
    }
  }

  updateParams = (property, value) => {
    if (property === 'departure') this.departurePicker.current.close()
    if (['kinds', 'resorts', 'properties'].includes(property)) this.refineFilters.current.open()

    let newValue = value
    if (property === 'arrival' || property === 'departure') newValue = value.format('YYYY-MM-DD')
    this.props.updateQueryString(property, newValue)

    this.props.onChange(property, value)
  }

  getSearchAndBookRoute = () => {
    if (process.env.RAZZLE_APP === 'dierenbos') {
      return trans('routes.search_book_dierenbos')
    }

    return trans('routes.search_book')
  }

  render = () => {
    const { columnClass, filterableProperties, template, results, showAdvancedFilters, params, petsAllowed } = this.props

    return (
      <>
        <div className={`${columnClass} column-company`}>
          <SubjectPicker onChange={subjects => this.updateParams('subjects', subjects)} petsAllowed={petsAllowed} />
        </div>
        <div className={`${columnClass} column-arrival`}>
          <ArrivalDatePicker
            toggle={this.toggle}
            onChange={date => this.updateParams('arrival', date)}
          />
        </div>
        <div className={`${columnClass} column-departure`}>
          <DepartureDatePicker
            ref={this.departurePicker}
            toggle={showAdvancedFilters ? this.toggle : null}
            onChange={date => this.updateParams('departure', date)}
          />
        </div>
        {(template === 'search_form' && results && !showAdvancedFilters) && (
          <div className='col-md-3 p-2 column-button'>
            <Link to={`${this.getSearchAndBookRoute()}?${params}`} className='btn btn-primary-color btn-block'>
              <span className='show-view d-block text-center'>{trans('refine.view')}</span>
              <span className='amount'>
                {`${results.filter(r => r.arrival_date).length} `}
                {trans('label.holiday')}
                {results.length > 1 && (
                  <span>s</span>
                )}
              </span>
            </Link>
          </div>
        )}
        {showAdvancedFilters && (
          <div className='col-md-3 px-0'>
            <RefineFiltersPicker
              ref={this.refineFilters}
              filterableProperties={filterableProperties}
              onChange={this.updateParams}
            />
          </div>
        )}
      </>
    )
  }
}

Filters.defaultProps = {
  columnClass: 'col-md-3 px-0',
  onChange: () => {},
  petsAllowed: true
}

Filters.propTypes = {
  columnClass: PropTypes.string,
  filterableProperties: PropTypes.array,
  focus: PropTypes.object, // eslint-disable-line react/no-unused-prop-types
  focusPriority: PropTypes.bool, // eslint-disable-line react/no-unused-prop-types
  setLoading: PropTypes.func,
  initialize: PropTypes.func,
  template: PropTypes.string,
  results: PropTypes.array,
  onChange: PropTypes.func,
  showAdvancedFilters: PropTypes.bool,
  params: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  petsAllowed: PropTypes.bool,
  updateQueryString: PropTypes.func.isRequired
}

const mapState = (state, ownProps) => ({
  params: getQueryString(state, ownProps.focus, ownProps.focusPriority)
})

const mapDispatch = dispatch => ({
  initialize: () => Promise.all([
    dispatch(fetchSubjects()),
    dispatch(fetchPropertyGroups())
  ]),
  setLoading: () => dispatch(setIsLoading(false)),
  updateQueryString: params => dispatch(updateQueryString(params))
})

export default connect(mapState, mapDispatch)(Filters)
